import styled from '@emotion/styled'
import { flexCenterContent } from 'styles/positioning'
import { color, padding, typography } from 'stylist'

export const ErrorPage = styled.div`
  height: 100vh;
  color: ${color('white')};
  text-align: center;

  ${flexCenterContent};
`

export const ErrorContainer = styled.div`
  max-width: 95%;
  width: 600px;
`

export const ErrorContent = styled.div`
  ${padding('xs')};
  ${typography('body4Medium')};
`

export const ErrorFooter = styled.div`
  ${padding('xs')};
`



// WEBPACK FOOTER //
// ./src/components/ErrorPage.js